<div
  *ngIf="props.label"
  class="template__container"
  [ngClass]="{
    'pe-3': props.tooltip,
    'template__container--placeholder': props.placeholder,
    'text-danger': props.tbc
  }"
  [innerHTML]="props.label | castObservable | async"
></div>

<lui-routed-label
  *ngIf="props.routedLabel"
  [routedLabel]="props.routedLabel"
></lui-routed-label>
